var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c(
                  "p",
                  {
                    staticClass: "modal-card-title",
                    class: { "is-flex-items-center": _vm.showIcon },
                  },
                  [
                    _vm.showIcon
                      ? _c(
                          "span",
                          {
                            staticClass: "icon is-medium",
                            class: `has-text-${_vm.iconType}`,
                            staticStyle: { "margin-right": "0.5rem" },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-36px",
                              class: `${_vm.iconName}`,
                            }),
                          ]
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "ml-2" }, [_vm._v("Authorise")]),
                  ]
                ),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c("article", [
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass:
                          "has-text-success has-text-weight-semibold is-size-6",
                      },
                      [
                        _vm._v(
                          "Final value to be authorise: " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.totalSelectedItems,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "mt-1 columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Claim Number"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quoteValues.claimNo,
                                expression: "quoteValues.claimNo",
                              },
                            ],
                            staticClass: "input",
                            attrs: {
                              type: "text",
                              placeholder: "Claim Number",
                            },
                            domProps: { value: _vm.quoteValues.claimNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.quoteValues,
                                  "claimNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Assessor"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.quoteValues.assessorName,
                                expression: "quoteValues.assessorName",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            attrs: { type: "text", placeholder: "Assessor" },
                            domProps: { value: _vm.quoteValues.assessorName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.quoteValues,
                                  "assessorName",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Excess Amount"),
                        ]),
                        _c(
                          "div",
                          { staticClass: "control" },
                          [
                            _c("vue-numeric", {
                              staticClass: "input",
                              attrs: {
                                min: 0,
                                format: "",
                                placeholder: "Excess",
                                symbol: _vm.$company.currency.symbol,
                                precision: 2,
                              },
                              model: {
                                value: _vm.quoteValues.excess,
                                callback: function ($$v) {
                                  _vm.$set(_vm.quoteValues, "excess", $$v)
                                },
                                expression: "quoteValues.excess",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "column" }),
                  ]),
                ]),
              ]),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  style: `justify-content: flex-${_vm.buttonLocation}`,
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: {
                        "data-tooltip": "Authorise this quote",
                        disabled: _vm.disableAuthorise,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.authorise()
                        },
                      },
                    },
                    [_vm._v("Authorise")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip is-tooltip-topright",
                      attrs: { "data-tooltip": "Cancel Authorisation" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }